import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      permissions: 'permissions',
      activeModules: 'appModules/activeModules',
    }),
  },
  methods: {
    hasModule(module) {
      if (this.permissions.includes(module)) {
        return true;
      }
      return false;
    },
  },
};
